import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import StockSeriesManager from '../components/StockSeriesManager';
import { FormField, EmptyState } from '../components/ui';

export default function StockSeriesPage() {
  const [products, setProducts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get('/stocks/product-codes');
      if (r.data.success) setProducts(r.data.data || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { fetchProducts(); }, [fetchProducts]);

  const filtered = !search ? products : products.filter(p =>
    (p.product_code || '').toLowerCase().includes(search.toLowerCase()) ||
    (p.sample_name || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="master-detail-page">
      {/* SOL: ÜRÜN KODU LİSTESİ */}
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-secondary)', borderRadius: 12, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div style={{ padding: 12, borderBottom: '1px solid var(--border-secondary)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <h3 style={{ margin: 0, fontSize: '0.95rem' }}>Ürün Kodları</h3>
            <span style={{ fontSize: '0.75rem', color: 'var(--text-tertiary)' }}>{products.length} ürün</span>
          </div>
          <FormField fullWidth>
            <input
              placeholder="Ürün kodu / ad ara..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </FormField>
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {loading && <div style={{ padding: 24, textAlign: 'center', color: 'var(--text-tertiary)' }}>Yükleniyor...</div>}
          {!loading && filtered.length === 0 && (
            <EmptyState
              compact
              title={products.length === 0 ? 'Ürün kodu yok' : 'Sonuç yok'}
              description={products.length === 0 ? 'Stok kartlarına ürün kodu girin.' : 'Eşleşen sonuç bulunamadı'}
            />
          )}
          {!loading && filtered.map(p => {
            const isActive = selected?.product_code === p.product_code;
            return (
              <button
                key={p.product_code}
                type="button"
                onClick={() => setSelected(p)}
                style={{
                  display: 'block', width: '100%', textAlign: 'left',
                  padding: '10px 12px', border: 'none',
                  background: isActive ? 'var(--accent-glow)' : 'transparent',
                  borderLeft: isActive ? '3px solid var(--accent-primary)' : '3px solid transparent',
                  borderBottom: '1px solid var(--border-secondary)',
                  color: 'var(--text-primary)', cursor: 'pointer', fontFamily: 'inherit',
                }}
              >
                <div style={{ fontFamily: 'monospace', fontWeight: 700, color: isActive ? 'var(--accent-primary)' : 'var(--text-primary)', fontSize: '0.85rem' }}>
                  {p.product_code}
                </div>
                <div style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {p.sample_name}
                </div>
                <div style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)', marginTop: 2 }}>
                  {p.variant_count} varyant
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* SAĞ: SERİ YÖNETİCİSİ */}
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-secondary)', borderRadius: 12, padding: 16, overflow: 'auto' }}>
        {!selected ? (
          <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-tertiary)', fontSize: '0.9rem', flexDirection: 'column', gap: 8 }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ opacity: 0.3 }}>
              <path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>
            </svg>
            <div><span className="desktop-only">Soldan</span><span className="mobile-only">Yukarıdan</span> bir ürün kodu seçin</div>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: 14, paddingBottom: 12, borderBottom: '1px solid var(--border-secondary)' }}>
              <div style={{ fontSize: '0.78rem', color: 'var(--text-tertiary)' }}>Ürün Kodu</div>
              <div style={{ fontFamily: 'monospace', fontSize: '1.1rem', fontWeight: 700, color: 'var(--accent-primary)' }}>{selected.product_code}</div>
              <div style={{ fontSize: '0.82rem', color: 'var(--text-secondary)', marginTop: 4 }}>{selected.sample_name} — {selected.variant_count} varyant</div>
            </div>
            <StockSeriesManager productCode={selected.product_code} />
          </>
        )}
      </div>
    </div>
  );
}
